import { render, staticRenderFns } from "./membershipProgramList.vue?vue&type=template&id=b94776a0&scoped=true&"
import script from "./membershipProgramList.vue?vue&type=script&lang=js&"
export * from "./membershipProgramList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94776a0",
  null
  
)

export default component.exports